import { useMutation } from "@/compat/reactQuery";
import reactQueryUtils from "../../../utils/reactQueryUtils";
import queryKeys from "../../../constants/queryKeys";
import actionPresetService from "../../services/actionPresetService";

const useAddActionPreset = () =>
  useMutation(actionPresetService.addNew, {
    onSuccess: (data, variables) => {
      // Incident presets are only listed once a saved template uses them, so a refetch would drop the new one.
      if (!variables?.subjectId)
        reactQueryUtils.client.setQueriesData(
          { queryKey: [queryKeys.actionPresets, null] },
          (previous) => (previous ? [...previous, data] : previous)
        );
    },
    onSettled: (_data, _error, variables) => {
      if (variables?.subjectId)
        reactQueryUtils.client.invalidateQueries([
          queryKeys.actionPresets,
          variables.subjectId,
        ]);
    },
  });

export default useAddActionPreset;
